import { render, staticRenderFns } from "./StaticPacket.vue?vue&type=template&id=57e42a8a&scoped=true"
import script from "./StaticPacket.vue?vue&type=script&lang=js"
export * from "./StaticPacket.vue?vue&type=script&lang=js"
import style0 from "./StaticPacket.vue?vue&type=style&index=0&id=57e42a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e42a8a",
  null
  
)

export default component.exports